import {Injectable} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {LoadingController, ToastController} from '@ionic/angular';

@Injectable({providedIn: 'root'})
export class TranslationService {
  private languageCode: string;
  private loadingEnabled = false;
  private loading: HTMLIonLoadingElement;
  constructor(
    private translateService: TranslateService,
    private toastController: ToastController,
    private loadingCtrl: LoadingController
  ) {
  }

  async setLanguage(languageCode: string) {
    if (this.languageCode === languageCode) {
      return;
    }
    this.languageCode = languageCode;
    this.translateService.resetLang(languageCode);
    this.translateService.use(languageCode);
    await this.showLoading();
    this.translateService
      .reloadLang(languageCode)
      .toPromise()
      .then(() => {
        this.hideLoading();
        if (this.languageCode === languageCode) {
          this.translateService.use(languageCode)
        }
      }).catch(async (e) => {
        this.hideLoading();
        const toast = await this.toastController.create({
          message: this.instant('Translation request error'),
          duration: 3000
        });
        toast.present();
        console.error(e);
      });
  }

  async showLoading() {
    if (!this.loadingEnabled) {
      this.loadingEnabled = true;
      this.loading = await this.loadingCtrl.create({
        animated: false,
        showBackdrop: true,
        backdropDismiss: true
      });
      // loadingEnabled might be changed during await
      if (this.loadingEnabled) {
        await this.loading.present();
        setTimeout(() => this.hideLoading(), 4500);
      }
    }
  }

  async hideLoading() {
    const top = await this.loadingCtrl.getTop();
    if (this.loadingEnabled && top) {
      this.loadingCtrl.dismiss();
      this.loadingEnabled = false;
    }
  }

  get(key: string | Array<string>, interpolateParams?: object): Promise<any> {
    return this.translateService.get(key, interpolateParams).toPromise();
  }

  instant(key: string | Array<string>, interpolateParams?: object) {
    return this.translateService.instant(key, interpolateParams);
  }
}
